import { atom } from 'recoil';

const permissionsState = atom({
  key: 'permissionsState',
  default: null,
});

export default permissionsState;
